import Connection from "./connection";
import Stack from "./stack";

const FAKE_CONNECTION = {
	send() {},
	onOpen: [],
	onClose: [],
	onMessage: [],
};

const FAKE_DATA = [
	{ channel: "general.email.notification", created: 1563889893, subject: "Víkend u našich", content: "Čau bráško, máš příští víkend čas? Že bychom konečně vyrazili na chalupu." },
	{ channel: "general.calendar.notification", created: 1563889893, displayed: 1, subject: "Přidali jsme mapovou vrstvu", content: "Lyžujete? To se vám bude líbit!" },
];

export default class Demo extends Stack {
	constructor() {
		super(FAKE_CONNECTION as unknown as Connection);
		this.unread = Math.floor(1 + (Math.random() * 9));
		this._updateButton();
	}

	onSession() {
		return super.onSession("green");
	}

	set _visibleButton(_value) {
		this.button.hidden = false;
	}

	_list() {
		this._buildItems(FAKE_DATA);
	}
}
